// extracted by mini-css-extract-plugin
export default {"productFooter":"ProductFooter_productFooter__mgP1q","termsAndConditions":"ProductFooter_termsAndConditions__tuhCV"};